export default class CalendarUtils {
  /**
   * Returns first day visible in calendar "card"
   */
  static getStartDay (year, month) {
    let date = new Date(year, month - 1, 1, 0, 0, 0);
    let dayNumber = date.getUTCDay();

    if (dayNumber > 0) {
      date.setDate((-1 * dayNumber) + 1);
    }

    return this.formatDateForPHP(date);
  }

  /**
   * Returns last day visible in calendar "card"
   */
  static getEndDay (year, month) {
    let dateTemp = new Date(year, month, 0);
    let date = new Date(year, month - 1, dateTemp.getDate(), 0, 0, 0);
    let dayNumber = date.getUTCDay();

    if (dayNumber < 6) {
      date.setDate((date.getDate() + 6) - dayNumber);
    }

    return this.formatDateForPHP(date);
  }

  /**
   * Returns date since provided current date with given diff
   */
  static getDay (currentDate, diff) {
    let dateArray = currentDate.split('-').map(num => parseInt(num, 10));
    let newDate = new Date(dateArray[0], dateArray[1] - 1, dateArray[2], 0, 0, 0, 0);
    newDate.setDate(newDate.getDate() + diff);

    return this.formatDateForPHP(newDate);
  }

  /**
   * Returns list of dates in a given period
   */
  static getDaysList (year, month) {
    let start = this.getStartDay(year, month);
    let end = this.getEndDay(year, month);
    let startArray = start.split('-').map(num => parseInt(num, 10));
    let endArray = end.split('-').map(num => parseInt(num, 10));
    let endDate = new Date(endArray[0], endArray[1] - 1, endArray[2], 0, 0, 0, 0);
    let today = new Date();
    let tempDate = new Date(startArray[0], startArray[1] - 1, startArray[2], 0, 0, 0);
    let days = [];

    while (tempDate.getTime() <= endDate.getTime()) {
      days.push({
        number: tempDate.getDate(),
        date: this.formatDateForPHP(tempDate),
        isCurrentMonth: tempDate.getMonth() + 1 === month,
        isToday: today.getFullYear() === tempDate.getFullYear() && today.getMonth() === tempDate.getMonth() && today.getDate() === tempDate.getDate()
      });
      tempDate.setDate(tempDate.getDate() + 1);
    }

    return days;
  }

  /**
   * Format JS Date object for use with PHP REST API
   */
  static formatDateForPHP (date) {
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(num => num < 10 ? '0' + num : num).join('-');
  }

  /**
   * Returns day name according to given day number
   */
  static getDayName (dayNumber, short = false) {
    switch (dayNumber) {
      case 1: return short ? 'Pn' : 'Poniedziałek';
      case 2: return short ? 'Wt' : 'Wtorek';
      case 3: return short ? 'Śr' : 'Środa';
      case 4: return short ? 'Cz' : 'Czwartek';
      case 5: return short ? 'Pt' : 'Piątek';
      case 6: return short ? 'So' : 'Sobota';
      case 0: return short ? 'Nd' : 'Niedziela';
      default: return 'Błąd';
    }
  }

  /**
   * Returns day name according to given date
   */
  static getDayNameFromDate (date, short = false) {
    date = date.split('-').map(n => parseInt(n, 10));
    let dateObject = new Date(date[0], date[1] - 1, date[2]);
    let dayNumber = dateObject.getDay();

    return this.getDayName(dayNumber, short);
  }

  /**
   * Returns month name according to given month number
   */
  static getMonthName (monthNumber, short = false) {
    switch (monthNumber) {
      case 1: return short ? 'Sty' : 'Styczeń';
      case 2: return short ? 'Lut' : 'Luty';
      case 3: return short ? 'Mar' : 'Marzec';
      case 4: return short ? 'Kwi' : 'Kwiecień';
      case 5: return short ? 'Maj' : 'Maj';
      case 6: return short ? 'Cze' : 'Czerwiec';
      case 7: return short ? 'Lip' : 'Lipiec';
      case 8: return short ? 'Sie' : 'Sierpień';
      case 9: return short ? 'Wrz' : 'Wrzesień';
      case 10: return short ? 'Paź' : 'Październik';
      case 11: return short ? 'Lis' : 'Listopad';
      case 12: return short ? 'Gru' : 'Grudzień';
      default: return 'Błąd';
    }
  }

  /**
   * Returns days list for given month and year
   */
  static getMonthDays (month, year, useShortNames = true) {
    let numberOfDays = new Date(year, month, 0).getDate();
    let days = Array.from({ length: numberOfDays }, (v, k) => k + 1);

    return days.map(day => {
      let tempDate = new Date(year, month - 1, day);

      return {
        day,
        name: this.getDayName(tempDate.getDay(), useShortNames)
      };
    });
  }

  /**
   * Get day names for a given range
   */
  static getDayNames (periodStart, diff) {
    let startArray = periodStart.split('-').map(num => parseInt(num, 10));
    let startDate = new Date(startArray[0], startArray[1] - 1, startArray[2], 0, 0, 0, 0);
    let names = [];

    names.push({
      name: startDate.getDate() + ' ' +
            this.getMonthName(startDate.getMonth() + 1, true) + ' - ' +
            this.getDayName(startDate.getDay()) + '',
      date: this.formatDateForPHP(startDate)
    });

    for (let i = 1; i < diff; i++) {
      startDate.setDate(startDate.getDate() + 1);
      names.push({
        name: startDate.getDate() + ' ' +
              this.getMonthName(startDate.getMonth() + 1, true) + ' - ' +
              this.getDayName(startDate.getDay()) + '',
        date: this.formatDateForPHP(startDate)
      });
    }

    return names;
  }

  /**
   * Calculates next/prev date
   */
  static getDiffDate (startDate, diff) {
    let startArray = startDate.split('-').map(num => parseInt(num, 10));
    let newDate = new Date(startArray[0], startArray[1] - 1, startArray[2], 0, 0, 0, 0);
    newDate.setDate(newDate.getDate() + diff);

    return this.formatDateForPHP(newDate);
  }

  /**
   * Converts string YYYY-MM-DD to Date object
   */
  static convertStringToDate (stringDate) {
    let date = stringDate.split('-').map(num => parseInt(num, 10));
    let convertedDate = new Date(date[0], date[1] - 1, date[2], 0, 0, 0, 0);

    return convertedDate;
  }

  /**
   * Converts string YYYY-MM-DD hh:mm:ss to Date object
   */
  static convertDateTimeStringToDate (stringDate) {
    let datetime = stringDate.split(' ');
    let date = datetime[0].split('-').map(num => parseInt(num, 10));
    let time = datetime[1].split(':').map(num => parseInt(num, 10));
    let convertedDate = new Date(date[0], date[1] - 1, date[2], time[0], time[1], time[2], 0);

    return convertedDate;
  }

  /**
   * Converts string to timestamp
   */
  static convertDateToTimestamp (stringDate) {
    return +CalendarUtils.convertStringToDate(stringDate);
  }

  /**
   * Converts timestamp to string
   */
  static convertTimestampToString (timestamp) {
    let date = new Date();
    date.setTime(timestamp);

    return [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
  }
};
